<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 18 16"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path xmlns="http://www.w3.org/2000/svg" d="M13.8462 4V1.33333C13.8462 0 12.4615 0 12.4615 0H5.60769C5.60769 0 4.07908 0.00266659 4.15385 1.33333V4H1.38462C1.38462 4 0 4 0 5.33333V14.6667C0 16 1.38462 16 1.38462 16H16.6154C16.6154 16 18 16 18 14.6667V5.33333C18 4 16.6154 4 16.6154 4H13.8462ZM6.23077 2H11.7692V4H6.23077V2Z" :fill="color"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";
export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.iconArinet  },
  },
};
</script>
